import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { addYears, parse } from "date-fns";
import Input from "common/src/component/input";
import Select from "common/src/component/select";
import { RegisterStepWrapper } from "../styledComponents/StyledSignupLogin";
import {
  BirthdayWrapper,
  InvalidFeedback,
  StyledDatePicker,
  StyledFormRow,
} from "../styledComponents/AccountPage";
import {
  StyledButton,
  StyledFlexBetween,
  StyledFormGroup,
  StyledSelect,
} from "../styledComponents/CommonStyledComponents";

const RegisterStep2 = ({
  errors,
  touched,
  formData,
  navigation,
  handleChange,
  handleBlur,
  handlePhoneChange,
  handleOnPhoneBlur,
  handleDateChange,
  setTouchedOnRest,
  skin,
  checkForEmptyFields,
  serverSetup,
}) => {
  const {
    //gender,
    title,
    firstName,
    //middleName,
    lastName,
    address,
    city,
    zipCode,
    dateOfBirth,
    phone,
    country,
  } = formData;
  const { go, pause } = navigation;
  const { t, i18n } = useTranslation("");
  //let isValid = false;
  const isUK = country === "gb" ? true : false;
  const nextStep = isUK ? "stepUK" : "stepGDPR";
  const prevStep =
    formData.country !== "se" && formData.currency !== "sek"
      ? "first"
      : "stepIdent";
  const [birthDate, setBirthDate] = useState(null);
  const countrtData = serverSetup.countries.filter(
    (c) => c.code === country,
  )[0];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currentLanguage = i18n.language || window.localStorage.i18nextLng;

  const paramsForCheckUK = [
    "firstName",
    "lastName",
    "title",
    "gender",
    /*     "address",
    "city",
    "zipCode", */
    "dateOfBirth",
    "phone",
    /*  "country", */
  ];
  const paramsForCheck = [
    "firstName",
    "lastName",
    "address",
    "city",
    "zipCode",
    "gender",
    "dateOfBirth",
    "phone",
  ];
  const minDateOfBirth = addYears(new Date(), -100);
  const maxDateOfBirth = addYears(new Date(), -countrtData.age);

  useEffect(() => {
    if (!dateOfBirth) {
      setBirthDate(null);
      return;
    }
    if (dateOfBirth instanceof Date) {
      setBirthDate(dateOfBirth);
      return;
    }
    const parsed = parse(dateOfBirth, "yyyy-MM-dd", new Date());
    setBirthDate(Number.isNaN(parsed.getTime()) ? null : parsed);
  }, [dateOfBirth]);

  const isDateOfBirthValid = (value) =>
    value instanceof Date &&
    !Number.isNaN(value.getTime()) &&
    value.getTime() >= minDateOfBirth.getTime() &&
    value.getTime() <= maxDateOfBirth.getTime();

  /* on next check mandatory fields */
  const checkIsValid = () => {
    if (!isDateOfBirthValid(birthDate)) {
      handleDateChange(null);
      if (isUK) {
        setTouchedOnRest(paramsForCheckUK);
      } else {
        setTouchedOnRest(paramsForCheck);
      }
      return false;
    }
    if (isUK) {
      setTouchedOnRest(paramsForCheckUK);
      let hasErrors = 0;
      errors &&
        paramsForCheckUK.forEach((p) => {
          for (let key of Object.keys(errors)) {
            if (p === key) {
              hasErrors++;
            }
          }
        });
      if (hasErrors === 0) {
        //double check errors
        let dce = checkForEmptyFields(paramsForCheckUK);
        // console.log(dce.length)
        return dce.length === 0;
      } else {
        return false;
      }
    } else {
      setTouchedOnRest(paramsForCheck);
      let hasErrors = 0;
      errors &&
        paramsForCheck.forEach((p) => {
          for (let key of Object.keys(errors)) {
            if (p === key) {
              hasErrors++;
            }
          }
        });
      if (hasErrors === 0) {
        let dce = checkForEmptyFields(paramsForCheck);
        // console.log(dce.length)
        return dce.length === 0;
      } else {
        return false;
      }
    }
  };

  const handleDateChangeLocal = (date) => {
    setBirthDate(date);
    if (date instanceof Date && !Number.isNaN(date.getTime())) {
      handleDateChange(date);
    }
  };

  /* let titleOptions = [{ name: 'label_mr', value: 'Mr' }]; */
  let genderOptions = [
    { value: "male", name: "label_male" },
    { value: "female", name: "label_female" },
  ];

  return (
    <RegisterStepWrapper>
      {/* <PageheadlinePar dangerouslySetInnerHTML={{ __html: t('label_register_account') }}></PageheadlinePar> */}
      <StyledFormRow>
        <Input
          groupClass="form-group col-md-6 mb-3"
          name="firstName"
          label={"label_first_name"}
          value={firstName}
          type="text"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={
            errors.firstName && touched.firstName ? errors.firstName : null
          }
          autoFocus={true}
          placeholder={skin !== "rac"}
          required
        />
        <Input
          groupClass="form-group col-md-6 mb-3"
          name="lastName"
          label={"label_last_name"}
          value={lastName}
          type="text"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.lastName && touched.lastName ? errors.lastName : null}
          required
          placeholder={skin !== "rac"}
        />
      </StyledFormRow>
      {!isUK && (
        <StyledFormRow>
          <Input
            groupClass="form-group col-md-6 mb-3"
            name="address"
            label={"label_address"}
            value={address}
            type="text"
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.address && touched.address ? errors.address : null}
            placeholder={skin !== "rac"}
          />
          <Input
            groupClass="form-group col-md-6 mb-3"
            name="city"
            label={"label_city"}
            value={city}
            type="text"
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.city && touched.city ? errors.city : null}
            placeholder={skin !== "rac"}
          />
        </StyledFormRow>
      )}
      <StyledFormRow>
        {isUK && (
          <StyledFormGroup col={"col-md-6 mb-3"}>
            {skin === "rac" && (
              <label
                dangerouslySetInnerHTML={{ __html: t("label_title") }}
              ></label>
            )}
            <StyledSelect
              formControll
              onChange={(e) => handleChange(e)}
              onBlur={(e) => handleBlur(e)}
              name="title"
              value={title}
            >
              <option value="">
                {t("label_select_title", "Select title")}
              </option>
              <optgroup label="">
                <option
                  value="Mr"
                  dangerouslySetInnerHTML={{ __html: t("label_mr", "Mr") }}
                ></option>
              </optgroup>
              <optgroup label="">
                <option
                  value="Ms"
                  dangerouslySetInnerHTML={{ __html: t("label_ms", "Ms") }}
                ></option>
                <option
                  value="Mrs"
                  dangerouslySetInnerHTML={{ __html: t("label_mrs", "Mrs") }}
                ></option>
                <option
                  value="Miss"
                  dangerouslySetInnerHTML={{ __html: t("label_miss", "Miss") }}
                ></option>
              </optgroup>
            </StyledSelect>
            {errors.title && touched.title && (
              <InvalidFeedback
                className={"d-block"}
                dangerouslySetInnerHTML={{ __html: t(errors.title) }}
              ></InvalidFeedback>
            )}
          </StyledFormGroup>
        )}
        {!isUK && (
          <Input
            groupClass="form-group col-md-6 mb-3"
            name="zipCode"
            label={"label_post_code"}
            value={zipCode}
            type="text"
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.zipCode && touched.zipCode ? errors.zipCode : null}
            placeholder={skin !== "rac"}
          />
        )}

        <Select
          groupClass="form-group col-md-6 mb-3"
          name="gender"
          list={genderOptions}
          onChange={handleChange}
          onBlur={handleBlur}
          firstOption="label_select_gender"
          errors={errors.gender && touched.gender ? errors.gender : null}
          disabled={false}
          value={""}
          required
          label={skin === "rac" && "label_select_gender"}
        />
      </StyledFormRow>

      <StyledFormRow>
        <div className="form-group col-md-12 mb-12">
          <PhoneInput
            specialLabel={""}
            inputProps={{
              name: "phone",
              required: true,
            }}
            autoFormat={false}
            country={country === "dk" ? "" : country}
            value={phone}
            containerClass={errors.phone && touched.phone ? "is-invalid" : ""}
            inputClass={errors.phone && touched.phone ? "is-invalid " : ""}
            onChange={(value, country, e, formattedValue) =>
              handlePhoneChange(value, country, e, formattedValue)
            }
            onBlur={(value, country, e, formattedValue) =>
              handleOnPhoneBlur(value, country, e, formattedValue)
            }
            autoComplete={"tel"}
          />
          {errors.phone && touched.phone && (
            <InvalidFeedback
              dangerouslySetInnerHTML={{ __html: t(errors.phone) }}
            ></InvalidFeedback>
          )}
        </div>
      </StyledFormRow>
      <BirthdayWrapper>
        <label>{t("label_day_of_birth")}</label>
      </BirthdayWrapper>
      <StyledFormRow>
        <StyledDatePicker
          register
          minDate={minDateOfBirth}
          maxDate={maxDateOfBirth}
          value={birthDate}
          clearIcon={null}
          calendarIcon={null}
          format="dd/MM/yyyy"
          dayPlaceholder={t("DD")}
          monthPlaceholder={t("MM")}
          yearPlaceholder={t("YYYY")}
          locale={currentLanguage === "en" ? "en-GB" : currentLanguage}
          onChange={(date) => handleDateChangeLocal(date)}
          required={true}
        />
      </StyledFormRow>
      {errors.dateOfBirth && touched.dateOfBirth && (
        <InvalidFeedback
          className="d-block"
          dangerouslySetInnerHTML={{ __html: t(errors.dateOfBirth) }}
        ></InvalidFeedback>
      )}
      <StyledFlexBetween>
        <StyledButton
          fourth
          pub={skin === "pub"}
          colfourth={"col-md-4"}
          type="button"
          onClick={() => go(prevStep)}
          dangerouslySetInnerHTML={{ __html: t("label_go_back", "Previous") }}
        ></StyledButton>
        <StyledButton
          btnCol
          pub={skin === "pub"}
          type="button"
          onClick={() => (checkIsValid() ? go(nextStep) : pause())}
          dangerouslySetInnerHTML={{ __html: t("label_next", "Next") }}
        ></StyledButton>
      </StyledFlexBetween>
    </RegisterStepWrapper>
  );
};

export default RegisterStep2;
